const stages =
{
    helmet :
    {
        title : 'Points d\'intérêts' ,
        metas : []
    }
};

export default stages ;